module.exports = __webpack_public_path__ + "static/img/nuevos_03.9002b901.jpg";